/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/insurance'
export default icon
